export enum SourceApp {
    Panel = 1,
    EndUser,
}